import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './MyBookingList.html?raw';
import domConstruct from 'dojo/dom-construct';
import connect from 'dojo/_base/connect';
import EventBookingEdit from '../EventBookingEdit/EventBookingEdit';
import GenericDialog from '../../GenericDialog/GenericDialog';
import Accordion from '../../Controls/Accordion/Accordion';

class MyBookingList extends compose(_WidgetBaseSP) {
    [key: string]: any;
    templateString: any = template;

    _editFormToEntityIdMapping: any = [];
    _entityList: any = [];

    constructor() {
        super(...(arguments as unknown as []));
        this._editFormToEntityIdMapping = [];
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        (connect as any).subscribe("event/booked", lang.hitch(this, "loadList"))

        this.loadList();
    }

    _handleUrlParameters() {
        var urlParams = location.search;

        if (urlParams != "" && urlParams != null && typeof (urlParams) != "undefined") {
            var pathParts = location.pathname.split("/");
            var action = pathParts[pathParts.length - 1];

            this.siteAction(action, urlParams);
        }
    }

    siteAction(action: any, paramString: any) {
        this._siteAction = action;
        // zb ?id=xyz&type=abc
        var paramList = paramString.slice(1);
        // id=xyz&type=abc

        paramList = paramList.split("&");
        // [id=xyz, type=abc]

        if (action.toUpperCase() == "VIEW") {
            // zb /mybookings/view?id=000081a5:0000001a // Achtung: so ist das relativ offen... evtl brauchts noch einen Key oder so

            for (var i = 0; i < paramList.length; i++) {
                var param = paramList[i].split("=");
                //console.log("action view", param);
                if (param[0].toUpperCase() == "ID") {
                    var entityID = param[1]; // ekus-ID!

                    (this as any).showBookingDialog(entityID, true);
                }
            }
        }
    }

    showBookingDialog(id: any) {
        for (var i = 0; i < this._entityList.length; i++) {
            var entity = this._entityList[i];

            if (entity.ID == id) {

                var editForm = new (EventBookingEdit as any)({
                    entity: entity
                });

                var dlg = new (GenericDialog as any)({
                    header: this._getBookingLabel(entity),
                    subTitle: "view, edit or comment your booking below"
                });
                dlg.set("topCloseBtn", true);
                dlg.addNodeToContent(editForm.domNode);
                dlg.show();

                editForm.shown();

                return;
            }
        }

        alert("'" + id + "' not found");
    }

    loadList() {
        //var tableNode = domConstruct.create("div", {}, this.domNode);
        this.StandbyStart();

        this.RequestManager.post(
            (window as any).appRoot + "Zal/GetMyBookings",
            {
                "JsonData": JSON.stringify({
                    status: null,
                    type: null
                })
            },
            lang.hitch(this, "_onGetMyBookings_Response"),
            lang.hitch(this, "_onGetMyBookings_Error")
        );
    }

    _onClick_Refresh(evt: any) {
        this.loadList();
    }

    pad(num: any, size: any) {
        var s = "000000000" + num;
        return s.substr(s.length - size);
    }

    _getBookingLabel(entity: any) {
        var item = entity;

        var datetimeLabel;

        var options: any = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };

        if (item.date_start) {

            var date_start = new Date(item.date_start);
            var date_end = new Date(item.date_end);

            datetimeLabel = "{0} - {1}".format(date_start.toLocaleDateString('de-DE', options), date_end.toLocaleDateString('de-DE', options));

            if (!item.date_end) {

                datetimeLabel = "{0} - {1}".format(date_start.toLocaleDateString('de-DE', options), this.translations["EventBooking_NoDateFixed"]);
                //
            }else if (date_start.getDate() == date_end.getDate()) {
                datetimeLabel = "{0} - {1}:{2}".format(date_start.toLocaleDateString('de-DE', options), this.pad(date_end.getHours(), 2), this.pad(date_end.getMinutes(), 2));
            }
        } else {
            if (item.date_1) {
                var date_1 = new Date(item.date_1);
                datetimeLabel = date_1.toLocaleDateString('de-DE', options);
            } else {
                datetimeLabel = this.translations["EventBooking_NoDateFixed"];//"no date fixed yet";
            }
        }

        var statusLabel = "<div class=\"w3-col s12 m6 l3\"><span style=\"color: {0};\">&#9724;</span> {1}</div>".format(item.ref_booking_status.tmp_css_color, item.ref_booking_status.Name);

        //return "{3} <b>{0}</b>: {2} {1}".format(datetimeLabel, item.Name, statusLabel, item.Number);
        return "<div class=\"w3-row\">" +
            "<div class=\"w3-col s12 m6 l3\">{3}</div><div class=\"w3-col s12 m6 l3\"><b>{0}</b></div>{2}<div class=\"w3-col s12 m6 l3\">{1}</div>".format(datetimeLabel, item.Name, statusLabel, item.Number) +
            "</div>";
    }

    _onGetMyBookings_Response(data: any) {
        this.StandbyStop();

        console.log("_onGetMyBookings_Response:: ", data);

        this._entityList = data;

        var tableNode = this.listContainer;
        domConstruct.empty(tableNode);
        this._editFormToEntityIdMapping = [];

        var listWidget: any = new Accordion();


        for (var i = 0; i < data.length; i++) {
            var item = data[i];


            var editForm = new (EventBookingEdit as any)({
                entity: item
            });

            editForm.on("cancellationDone", lang.hitch(this, "loadList"));



            listWidget.add(
                item.ID,
                this._getBookingLabel(item),
                editForm.domNode
            );

            this._editFormToEntityIdMapping.push({ "itemID": item.ID, "editForm": editForm });
        }

        listWidget.createEntries();
        listWidget.placeAt(tableNode);
        listWidget.on("shown", lang.hitch(this, "_onAccordionEntryShown"));

        // suchparameter nach listenzeichnen behandeln
        this._handleUrlParameters();

        /*
        var tableObj = new Tabulator(tableNode, {
            data: data,
            height: "311px",
            responsiveLayout: "collapse",
            responsiveLayoutCollapseStartOpen: false,
            columns: [
                { formatter: "responsiveCollapse", width: 30, minWidth: 30, align: "center", resizable: false, headerSort: false },
                {
                    title: "Number", field: "Number", formatter: function (cell, formatterParams) {
                        var value = cell.getValue();
                        var row = cell.getRow();
                        var entity = row.getData();
                        var cellElement = cell.getElement();

                        domStyle.set(cellElement, "backgroundColor", entity.ref_booking_status.tmp_css_color);

                        return value;
                    },
                    headerSort: false
                },
                { title: "Name", field: "Name", headerSort: false },
                { title: "Status", field: "ref_booking_status.Name", formatter: function (cell, formatterParams) {
                        var value = cell.getValue();
                        var row = cell.getRow();
                        var entity = row.getData();
                        var cellElement = cell.getElement();

                        domStyle.set(cellElement, "backgroundColor", entity.ref_booking_status.tmp_css_color);

                        return value;
                    },
                    headerSort: false
                },
                {
                    title: "From", field: "date_start", headerSort: false, formatter: function (cell) {
                        var value = cell.getValue();
                        if (value != null) {
                            var date = new Date(value);
                            var options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
                            return date.toLocaleDateString('de-DE', options);
                        }
                        return value;
                    }
                },
                {
                    title: "Until", field: "date_end", headerSort: false, formatter: function (cell) {
                        var value = cell.getValue();
                        if (value != null) {
                            var date = new Date(value);
                            var options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
                            return date.toLocaleDateString('de-DE', options);
                        }
                        return value;
                    }
                },
                {
                    title: "edit", field: "ID", headerSort: false, formatter: lang.hitch(this, function (cell) {
                        var value = cell.getValue();
                        var row = cell.getRow();
                        var entity = row.getData();
                        if (value != null) {
                            var btn = domConstruct.create("button", {
                                innerHTML: "edit"
                            });
                            on(btn, "click", lang.hitch(this, "_onClick_EditBtn", entity))
                            return btn;
                        }
                        return "";
                    })
                }
            ],
        });
        */
    }

    _onAccordionEntryShown(entry: any, entryNode: any) {
        //console.log("_onAccordionEntryShown", entry, entryNode);

        for (var i = 0; i < this._editFormToEntityIdMapping.length; i++) {
            var mapItem = this._editFormToEntityIdMapping[i];

            if (entry.id == mapItem.itemID) {

                mapItem.editForm.shown();
                return;
            }
        }
    }

    // JS2TS: the original object literal declared _onGetMyBookings_Error twice. In JS the last key wins,
    // so the empty definition further below is the one actually installed on the prototype. TS forbids
    // duplicate method implementations, so this earlier (dead) definition is preserved only as a comment
    // to keep runtime behavior 1:1 (never fixed):
    // _onGetMyBookings_Error(error: any) {
    //     this.StandbyStop();
    // }
    //_onClick_EditBtn: function (entity) {
    //    //console.log(entity.ID);
    //    var editForm = new EventBookingEdit({
    //        entity: entity
    //    });

    //    var dlg = new GenericDialog();
    //    dlg.set("header", "edit booking");
    //    dlg.set("CloseBtn", true);
    //    dlg.addNodeToContent(editForm.domNode);
    //    dlg.show();
    //},
    _onGetMyBookings_Error(error: any) {

    }
}
MyBookingList.prototype.declaredClass = 'more.Legacy.Zal.MyBookingList';

export default mdsWidget(MyBookingList);
